<template>
  <section class="commercial-returns-form">
    <former-alert type="warning">
      {{ messageAlert }}
    </former-alert>
    <commercial-form
      :loading="loading"
      :sections="sections"
      @submit="verifyOverlap"
    />

    <popup-confirm
      v-if="popup"
      title="Confirmação"

      :loading="loading"

      confirm-button-label="Salvar regra"
      cancel-button-label="Não salvar"

      @close="close"
      @confirm="submit"
    >
      <template>
        <p class="former-section-popup-message">
          {{ messagePopupConfirmation }}
          <b>{{ overlappingRules[0].store.name }}: </b>
        </p>

        <div class="former-section-popup-wrapper">
          <ul>
            <li
              v-for="(overlappingRule, index) in overlappingRules"
              :key="overlappingRule.id"
              class="former-section-popup-list-item"
            >
              {{ overlappingRuleText(overlappingRule, index) }}
            </li>
          </ul>
        </div>
      </template>
    </popup-confirm>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import former from '@/helpers/mixins/former';
  import scrollHelper from '@/helpers/views/scroll';
  import FormerAlert from '@/components/Former/Alert.vue';
  import PopupConfirm from '@/components/Popup/Confirm.vue';

  import { stringify } from '@/helpers/filters';

  import {
    prioritiesSections as sections,
  } from '@/views/Settings/Commercial/Form/sections';

  import commercialMap, {
    storesMap,
    returnsMap,
  } from '@/views/Settings/Commercial/Form/maps';

  import CommercialForm from '@/views/Settings/Commercial/Form.vue';

  export default {
    name: 'CommercialReturnsForm',
    components: {
      CommercialForm,
      FormerAlert,
      PopupConfirm,
    },
    mixins: [former],
    data() {
      return {
        sections: sections(),
        messageAlert: 'As regras aplicadas aqui irão determinar quais condições serão usadas nas simulações e propostas.',
        messagePopupConfirmation: '',
        popup: false,
      };
    },
    computed: {
      ...mapState([
        'financingReturnRules',
      ]),

      loading() {
        return this.financingReturnRules[this.$route.params.id ? 'update' : 'create'].loading;
      },

      overlappingRules() {
        return this.financingReturnRules.overlappings.result.financing_return_rules;
      },
    },
    mounted() {
      this.getReturn();

      this.setFieldValue(returnsMap.min_return, stringify(0));
      this.setFieldCallback(returnsMap.min_return, this.changedMinReturn);
      this.takeOutSeparatorFromSection('commercialAssociation');
    },
    methods: {
      getReturn() {
        const {
          id,
        } = this.$route.params;

        if (id) {
          this.setFieldProcessingBulk(commercialMap, true);
          this.setFieldProcessingBulk(returnsMap, true);

          this.$store
            .dispatch('financingReturnRules/read', { id })
            .then(this.gotReturn);
        }
      },
      gotReturn() {
        const {
          store_id: storeID,
          vehicle_model: vehicleModel,
          bank,
          max_return: maxReturn,
          min_return: minReturn,
          quota_preference: quotaPreference,
          return_preference: returnPreference,
        } = this.financingReturnRules.read.item;

        this.setFieldValue(storesMap.store_id, storeID);
        this.setFieldValue(commercialMap.has_bank, !!bank);
        this.setFieldValue(commercialMap.has_vehicle, !!vehicleModel);

        if (bank) {
          this.setFieldValue(commercialMap.bank_id, bank.id);
        }

        if (vehicleModel) {
          this.setFieldValue(commercialMap.vehicle_model_id, vehicleModel.id);
        }

        this.setFieldValue(returnsMap.max_return, stringify(maxReturn));
        this.setFieldValue(returnsMap.min_return, stringify(minReturn));
        this.setFieldValue(returnsMap.quota_preference, stringify(quotaPreference));
        this.setFieldValue(returnsMap.return_preference, stringify(returnPreference));

        this.setFieldProcessingBulk(commercialMap, false);
        this.setFieldProcessingBulk(returnsMap, false);
      },
      changedMinReturn() {
        const minReturn = this.getFieldValue(returnsMap.min_return);

        this.setFieldValidations(returnsMap.max_return, [{
          type: 'greaterThan',
          count: minReturn,
          equal: true,
        }]);
      },
      verifyOverlap() {
        const {
          id,
        } = this.$route.params;

        this.$store
          .dispatch('financingReturnRules/overlappings', {
            store_id: this.getFieldValue(storesMap.store_id),
            bank_id: this.getFieldValue(commercialMap.bank_id),
            vehicle_model_id: this.getFieldValue(commercialMap.vehicle_model_id),
            not_id: id,
          })
          .then(this.verifyOverlapSuccess)
          .catch(this.submit);
      },
      verifyOverlapSuccess() {
        const {
          financing_return_rules: financingReturnRules,
        } = this.financingReturnRules.overlappings.result;

        if (financingReturnRules.length > 0) {
          this.popup = true;
          this.messagePopupConfirmation = financingReturnRules.length > 1
            ? 'A nova regra irá sobrepor as seguintes regras já cadastradas na loja '
            : 'A nova regra irá sobrepor a seguinte regra já cadastrada na loja';
        } else {
          this.submit();
        }
      },
      close() {
        this.popup = false;
      },
      submit() {
        const {
          id,
        } = this.$route.params;

        const payload = {
          store_id: this.getFieldValue(storesMap.store_id),
          bank_id: this.getFieldValue(commercialMap.bank_id),
          vehicle_model_id: this.getFieldValue(
            commercialMap.vehicle_model_id,
          ),
          min_return: this.getFieldValue(returnsMap.min_return),
          max_return: this.getFieldValue(returnsMap.max_return),
          quota_preference: this.getFieldValue(returnsMap.quota_preference),
          return_preference: this.getFieldValue(returnsMap.return_preference),
        };

        if (id) {
          payload.id = id;
        }

        this.$store
          .dispatch(`financingReturnRules/${id ? 'update' : 'create'}`, payload)
          .then(this.submitSuccess)
          .catch(this.submitFailure);
      },
      submitSuccess() {
        this.$router.push({
          name: 'settings-commercial-returns',
        });
      },
      submitFailure() {
        const {
          error,
        } = this.financingReturnRules[this.$route.params.id ? 'update' : 'create'];

        this.setErrors({
          ...storesMap,
          ...commercialMap,
          ...returnsMap,
        }, error);

        this.close();
        scrollHelper();
      },
      takeOutSeparatorFromSection(id) {
        const sectionToTakeOutSeparator = this.getSection(id);
        sectionToTakeOutSeparator.separator = false;
      },
      overlappingRuleText(rule, index) {
        const {
          bank,
          vehicle_model: vehicle,
        } = rule;

        const vehicleName = vehicle ? `${vehicle.name} ${vehicle.version}` : 'todos os veículos';
        const bankName = bank ? bank.tradename : 'todos os bancos';

        return `${index + 1}. Regra aplicada para ${vehicleName} - ${bankName}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-section-popup-message {
    text-align: center;
  }

  .former-section-popup-wrapper {
    align-items: center;
    background-color: $gray-light;
    border-radius: $button-small * 0.5;
    display: flex;
    flex-direction: column;
    margin: $gutter-bigger (-$gutter-small) 0;
    padding: $gutter-small;
    justify-content: center;
  }

  .former-section-popup-list-item {
    list-style: none;
    padding: $gutter-small;
  }
</style>
